/* Root container */
.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

/* Editor container */
.editorContainer {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

/* Override MDEditor styles to match the wireframe */
.editorContainer :global(.w-md-editor) {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: none;
}

.editorContainer :global(.w-md-editor-toolbar) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #fafafa;
  padding: 8px;
}

/* Fix toolbar layout - ensure horizontal display, no wrapping */
.editorContainer :global(.w-md-editor-toolbar ul) {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  gap: 4px;
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.editorContainer :global(.w-md-editor-toolbar li) {
  display: inline-flex !important;
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.editorContainer :global(.w-md-editor-toolbar li::before) {
  display: none !important;
  content: none !important;
}

.editorContainer :global(.w-md-editor-toolbar li::marker) {
  display: none !important;
  content: none !important;
}

.editorContainer :global(.w-md-editor-toolbar li > button) {
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

.editorContainer :global(.w-md-editor-toolbar li > button:hover) {
  background-color: rgba(0, 0, 0, 0.08);
}

.editorContainer :global(.w-md-editor-text-input) {
  font-family: var(--font-reg, "Roboto", "Helvetica", "Arial", sans-serif);
  font-size: 14px;
  line-height: 1.6;
}

.editorContainer :global(.w-md-editor-text-pre > code),
.editorContainer :global(.w-md-editor-text-input) {
  font-size: 14px !important;
  line-height: 1.6 !important;
}

/* Editor content area */
.editorContainer :global(.w-md-editor-content) {
  background-color: #fff;
}

/* Hide the markdown preview/syntax highlighting overlay */
.editorContainer :global(.w-md-editor-text-pre) {
  display: none;
}

/*
 * The library renders visible text via the syntax-highlighting overlay
 * above (.w-md-editor-text-pre), leaving the underlying textarea's own
 * text transparent (-webkit-text-fill-color) by design. Since we hide
 * that overlay, the textarea's text must be made visible here instead,
 * or nothing typed will render.
 */
.editorContainer :global(.w-md-editor-text-input) {
  -webkit-text-fill-color: var(--color-fg-default) !important;
}

.editorContainer :global(.w-md-editor-area) {
  padding: 12px;
}

/* Make the textarea fill the editor content area */
.editorContainer :global(.w-md-editor-text),
.editorContainer :global(.w-md-editor-text-input) {
  width: 100%;
  height: 100%;
  min-height: 180px;
}

/* Placeholder styling */
.editorContainer :global(.w-md-editor-text-input::placeholder) {
  color: #999;
  font-style: normal;
}

/* Buttons container */
.buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

/* Base button styles */
.button {
  box-sizing: border-box;
  min-width: 80px;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-family: var(--font-semibold, "Roboto", "Helvetica", "Arial", sans-serif);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  cursor: pointer;
  transition: background-color 200ms ease, opacity 200ms ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Primary button (Save) */
.buttonPrimary {
  background-color: var(--pri-02, #28aae1);
  color: #fff;
}

.buttonPrimary:hover:not(:disabled) {
  background-color: var(--pri-02-dark, #1e8cba);
}

.buttonPrimary:disabled {
  background-color: var(--gray-l, #ccc);
  color: var(--gray-m, #999);
  cursor: not-allowed;
}

/* Secondary button (Cancel) */
.buttonSecondary {
  background-color: transparent;
  color: var(--gray-d, #4c4c4c);
  border: 1px solid var(--gray-l, #ccc);
}

.buttonSecondary:hover:not(:disabled) {
  background-color: var(--gray-xl, #f5f5f5);
}

.buttonSecondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Loading spinner */
.loadingSpinner {
  width: 14px;
  height: 14px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
